import React from "react";
var __jsx = React.createElement;
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import { useSelector } from 'react-redux';
import { getPageMetaData } from 'redux/content';
import { StyledLinearProgress } from './MetaUrlField.style';

var MetaPublicationDateField = function MetaPublicationDateField(_ref) {
  var formField = _ref.formField;

  var _useSelector = useSelector(getPageMetaData),
      pageMetaData = _useSelector.value,
      loading = _useSelector.loading;

  if (loading) {
    return __jsx(StyledLinearProgress, null);
  }

  return __jsx(React.Fragment, null, __jsx(FormattedMessage, {
    id: formField.labelId
  }), " :", ' ', (pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.publishedAt) !== undefined && __jsx(React.Fragment, null, __jsx(FormattedDate, {
    value: pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.publishedAt
  }), ' ', __jsx(FormattedTime, {
    value: pageMetaData === null || pageMetaData === void 0 ? void 0 : pageMetaData.publishedAt
  })));
};

export default MetaPublicationDateField;